import { Injectable } from '@angular/core';
// import { SegmentService } from 'ngx-segment-analytics';
import { Cargochief } from '../cargochief/cargochief.service';
import { APP_ENV } from '@domain/constants/app-variables';
import { UtilService } from '../util/util.service';
import { environment } from '@environment/environment';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { UserService } from '@service/user/user.service';
import { E, F } from '@angular/cdk/keycodes';

declare const window: any;

@Injectable({
	providedIn: 'root',
})
export class SegmentWrapperService {
	constructor(
		// private segment: SegmentService,
		public accountSettings: AccountSettingsService,
		private cargochief: Cargochief,
		private utilService: UtilService,
		private userService: UserService
	) {}

	fireSegmentIdentify(id: string, traits: any) {
		if (!window.analytics) {
			return;
		}

		let segmentPayload = traits;

		if (segmentPayload.id) {
			delete segmentPayload.id;
		}
		if (environment.environment == APP_ENV.PROD && this.userService.isCargochiefUser()) {
			return;
		}
		window.analytics.identify(id, segmentPayload);
		// this.segment.identify(id, segmentPayload);
	}

	fireSegmentEvent(eventName: string, payload: any) {
		return this.fireSegmentEventOptionalUser(eventName, payload, true);
	}

	fireSegmentEventOptionalUser(eventName: string, payload: any, requireUser: boolean) {
		try {
			if (!window.analytics) {
				return;
			}

			if (!this.utilService.isNullOrUndefined(this.cargochief.getAccountSettings())) {
				payload['demo_account'] = this.accountSettings.DEMO_ACCOUNT;
			} else {
				payload['demo_account'] = false; // assume not demo if there are no account settings
			}

			if (!this.utilService.isNullOrUndefined(this.cargochief.getUser())) {
				payload.user = this.cargochief.getUser();
				const loginSetupUser = this.cargochief.getLoginSetupUser();
				if (
					!this.utilService.isNullOrUndefined(payload.user) &&
					!this.utilService.isNullOrUndefined(loginSetupUser)
				) {
					payload.user['firstName'] = loginSetupUser['firstName'];
					payload.user['lastName'] = loginSetupUser['lastName'];
					payload.user['businessName'] = this.cargochief.BUSINESS_NAME;
				}
			}
			if (
				environment.environment == APP_ENV.PROD &&
				this.userService.isCargochiefUser() &&
				!this.utilService.isAccountTypeAdmin()
			) {
				return;
			}
			// if no userId is set do not fire segment event
			if (!payload?.user?.id && requireUser) {
				return;
			}
			payload['eventSource'] = 'C4_CLIENT';
			window.analytics.track(eventName, payload);
			// this.segment.track(eventName, payload).then(() => {});
		} catch (error) {}
	}
}
